// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1bSYx","modalFooterButton":"ModalNotes_modalFooterButton__gdTzT"};